import type { ReportingComparison } from '../../../types/reporting';
import { resolveComparablePriorPeriodStart } from './dateUtils';

export interface ComparablePriorContext {
    comparison?: ReportingComparison;
    date: string;
    priorDate?: string;
    granularity?: string;
    preset?: string;
}

/** True when the bucket can be compared to a real prior period (not invalid calendar days). */
export function hasComparablePriorPeriod({
    comparison,
    date,
    priorDate,
    granularity = 'week',
    preset,
}: ComparablePriorContext): boolean {
    if (!comparison) return false;
    if (priorDate) return true;
    return resolveComparablePriorPeriodStart(date, granularity, comparison, priorDate, preset) !== undefined;
}

/**
 * Use the backend prior metric when present; otherwise use 0 only when a real prior period exists.
 * Returns undefined when there is no valid comparison target (e.g. March 30 → February).
 */
export function resolveComparablePriorMetricValue(
    priorMetric: number | undefined | null,
    context: ComparablePriorContext,
): number | undefined {
    if (!context.comparison) return undefined;
    if (typeof priorMetric === 'number' && !Number.isNaN(priorMetric)) return priorMetric;
    return hasComparablePriorPeriod(context) ? 0 : undefined;
}
